import type { IconProps } from './types';

export const CopyIcon: React.FC<IconProps> = ({
  className,
  width = '16px',
  height = '16px',
  color = 'currentColor',
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="iconLeading" clipPath="url(#clip0_2207_815)">
      <path
        id="vector"
        d="M5.33331 5.33325V3.99992C5.33331 2.52716 6.52722 1.33325 7.99998 1.33325L12 1.33325C13.4727 1.33325 14.6666 2.52716 14.6666 3.99992V7.99992C14.6666 9.47268 13.4727 10.6666 12 10.6666H10.6666M5.33331 5.33325H3.99998C2.52722 5.33325 1.33331 6.52716 1.33331 7.99992V11.9999C1.33331 13.4727 2.52722 14.6666 3.99998 14.6666H7.99998C9.47274 14.6666 10.6666 13.4727 10.6666 11.9999V10.6666M5.33331 5.33325H7.99998C9.47274 5.33325 10.6666 6.52716 10.6666 7.99992V10.6666"
        stroke={color}
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2207_815">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
